import React , {   useState , useCallback , useRef, useEffect } from 'react';
import { io } from "socket.io-client";
import { v4 as uuid} from "uuid";

const useListenForUnreadChats = ( userId , authService) => {
    const chatSocket = useRef( null );
    const [ socketConnected , setSocketConnected ] = useState(uuid());
    const [ numUnread , setNumUnread ] = useState(0);

    
   const setupListnersOnSocket = ( socket ) => {
        //chatSocket.current.emit('authenticate', { accesstoken : '212312312' } , (response)=>{ alert('test');console.log('autenthicate' , response ); socketIoAuthenticatedSuccess.current = true; });
        // chatSocket.current.emit('addChatMessage', { msg :  } , (response)=>{ alert('test');console.log('autenthicate' , response ); socketIoAuthenticatedSuccess.current = true; });
        chatSocket.current.on('User:NumUnreadMessages:Update', function(msg) {
            setNumUnread( parseInt(msg.numUnreadMessages) );
        });

        chatSocket.current.emit('User:NumUnreadMessages:subscribeToChanges', { userId :  userId } , (response)=>{ 
            if( response.error ){ return; } 
            // setCurrentMessages( response.messages );
            // messagesDivRef.current.scrollTop =  messagesDivRef.current.scrollHeight;
        });

        chatSocket.current.emit('User:NumUnreadMessages:getUnread', { userId :  userId } , (response)=>{ 
            if( response.error ){ return; } 
            // setCurrentMessages( response.messages );
            // messagesDivRef.current.scrollTop =  messagesDivRef.current.scrollHeight;
        });

        
    };

    useEffect(()=>{
        return;
        chatSocket.current = io("https://devsuppliers.merchandisefabriek.nl", {
            path: "/chat/socket.io/",
            'reconnection': true,
            'reconnectionDelay': 1000,
            auth: {
                token: authService?.getCurrentIdentity()?.identity?.token
            }
        });

        chatSocket.current.on("connect", (reason) => {
            console.log('socket connected'  );
            setSocketConnected(true);
            setupListnersOnSocket();
            // else the socket will automatically try to reconnect
        });

        chatSocket.current.on("connect_error", (err) => {
            setSocketConnected(false);
        });

        chatSocket.current.on("disconnect", (reason) => {
            setSocketConnected(false);
            if (reason == "io server disconnect" || reason == 'transport error') {
            // the disconnection was initiated by the server, you need to reconnect manually
            }
            // else the socket will automatically try to reconnect
        });
        
        // fetchExistingChatData();

        return ()=>{
            chatSocket.current.disconnect();
        }
    } , []);


    return [  numUnread , socketConnected  ];
}

export default useListenForUnreadChats ;